import { ComponentWithSelectedAssetInDrawer } from 'layouts/ComponentWithSelectedAssetInDrawer';

import { UserItemsSnapshotCard } from './UserItemsSnapshotCard';

export const UserItemsSnapshot = (): JSX.Element => (
    <ComponentWithSelectedAssetInDrawer MainComponent={UserItemsSnapshotCard} />
);
